import React, { useState, useEffect } from 'react';
import cl from "../../css/mainStyle.module.css";
import EducationList from "./EducationList/EducationList";
import { coursesAPI, Course } from '../../api/api';

const Education = () => {
    const [courses, setCourses] = useState<Course[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadCourses = async () => {
            try {
                setLoading(true);
                const data = await coursesAPI.getAll();
                setCourses(data);
                setError(null);
            } catch (err) {
                setError('Не удалось загрузить курсы');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        loadCourses();
    }, []);

    if (loading) {
        return (
            <div className={`${cl.home__row}`}>
                <div className={`${cl.home__cell}`}>
                    <div className={`${cl.home__cell__block}`}>
                        <h2>Образовательные программы</h2>
                        <p>Загрузка курсов...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={`${cl.home__row}`}>
                <div className={`${cl.home__cell}`}>
                    <div className={`${cl.home__cell__block}`}>
                        <h2>Образовательные программы</h2>
                        <p className="error">{error}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`${cl.home__row}`}>
            <div className={`${cl.home__cell}`}>
                <div className={`${cl.home__cell__block}`}>
                    <h2>Образовательные программы</h2>
                    <p className={cl.home__blockText}>
                        Наши направления.
                    </p>
                    <EducationList courses={courses}/>
                </div>
            </div>
        </div>
    );
};

export default Education;